import { render, staticRenderFns } from "./form-region.vue?vue&type=template&id=3ad97600&"
import script from "./form-region.vue?vue&type=script&lang=js&"
export * from "./form-region.vue?vue&type=script&lang=js&"
import style0 from "./form-region.vue?vue&type=style&index=0&id=3ad97600&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports